/**
 * Created by orizis on 17/04/2018.
 */
import _ from 'lodash';

export const getSelectedPcp = state => _.get(state, 'member.medicalTeam.selectedPcp');
export const getHasDependents = state => _.get(state, 'member.medicalTeam.hasDependents');
export const getDependents = state => _.get(state, 'member.medicalTeam.dependents');
